$.TemplateMarketingDirectoryProductExport = {
    Steps: 4,
    Step: 1,
    Products: [],
    SearchTimeout: null,

    Language: () => $(".tpl-marketing-directory").data("lang"),

    SelectedLanguage: () => {
        const input = $(
            "#product-export-modal input[name='export-language']:checked",
        );
        if (!input.length)
            return {
                id: $.TemplateMarketingDirectoryProductExport.Language(),
                key: null,
                name: null,
            };
        return {
            id: input.val(),
            key: input.attr("data-language-key"),
            name: input.attr("data-language-name"),
        };
    },

    HasProduct: (partNumber) =>
        $.TemplateMarketingDirectoryProductExport.Products.some(
            (product) =>
                product.partNumber.toLowerCase() === partNumber.toLowerCase(),
        ),

    SelectedColumns: () =>
        $("#export-columns input[data-column]:checked")
            .map(function () {
                return $(this).attr("data-column");
            })
            .get(),

    GoToStep: (step) => {
        const self = $.TemplateMarketingDirectoryProductExport;
        self.Step = Math.max(1, Math.min(self.Steps, step));

        $("#product-export-modal .export-panel").addClass("d-none");
        $(
            `#product-export-modal .export-panel[data-step='${self.Step}']`,
        ).removeClass("d-none");

        $("#product-export-modal .export-progress li").each(function () {
            const step = parseInt($(this).attr("data-step"), 10);
            $(this)
                .toggleClass("active", step === self.Step)
                .toggleClass("done", step < self.Step)
                .find(".step")
                .prop("disabled", step >= self.Step);
        });

        $("#export-back").prop("disabled", self.Step === 1);
        $("#export-next").toggleClass("d-none", self.Step === self.Steps);
        $("#export-download").toggleClass("d-none", self.Step !== self.Steps);

        $("#product-export-modal .modal-body").scrollTop(0);

        self.Refresh();
    },

    Refresh: () => {
        const self = $.TemplateMarketingDirectoryProductExport;
        const columns = self.SelectedColumns();

        $("#export-selection-count").html(self.Products.length);
        $("#export-column-count").html(columns.length);
        $("#export-summary-products").html(self.Products.length);
        $("#export-summary-columns").html(columns.length);

        $("#export-selection-empty").toggleClass("d-none", self.Products.length > 0);
        $("#export-selection-clear").prop("disabled", self.Products.length === 0);

        $("#product-export-modal [data-group-count]").each(function () {
            const group = $(this).attr("data-group-count");
            const inputs = $(
                `#export-columns input[data-column][data-group='${group}']`,
            );
            const checked = inputs.filter(":checked");

            $(this).html(`${checked.length} / ${inputs.length}`);
            $(`#export-columns input[data-group='${group}']:not([data-column])`)
                .prop(
                    "checked",
                    inputs.length > 0 && checked.length === inputs.length,
                )
                .prop(
                    "indeterminate",
                    checked.length > 0 && checked.length < inputs.length,
                );
        });

        $("#export-search-results [data-part-number]").each(function () {
            $(this).toggleClass(
                "added",
                self.HasProduct($(this).attr("data-part-number")),
            );
        });

        const language = self.SelectedLanguage();
        $("#export-summary-language").text(language.name ? language.name : "");

        $("#export-next").prop(
            "disabled",
            (self.Step === 1 && self.Products.length === 0) ||
                (self.Step === 2 && columns.length === 0),
        );
        $("#export-download").prop(
            "disabled",
            self.Products.length === 0 || columns.length === 0,
        );
    },

    RenderSelection: () => {
        const self = $.TemplateMarketingDirectoryProductExport;
        const container = $("#export-selection");
        container.empty();

        for (let product of self.Products) {
            const chip = $(`
                <span class="export-chip">
                    <span class="part-number"></span>
                    <span class="name"></span>
                    <button type="button" class="remove"><i class="fa fa-xmark"></i></button>
                </span>
            `);
            chip.find(".part-number").text(product.partNumber);
            chip.find(".name").text(product.name ? product.name : "");
            chip.find(".remove").on("click", function () {
                self.RemoveProduct(product.partNumber);
            });
            container.append(chip);
        }

        self.Refresh();
    },

    ToggleProduct: (product) => {
        const self = $.TemplateMarketingDirectoryProductExport;
        if (self.HasProduct(product.partNumber))
            self.RemoveProduct(product.partNumber);
        else self.AddProducts([product]);
    },

    AddProducts: (products) => {
        const self = $.TemplateMarketingDirectoryProductExport;
        const known = self.Products.map((product) =>
            product.partNumber.toLowerCase(),
        );

        for (let product of products) {
            if (known.indexOf(product.partNumber.toLowerCase()) > -1) continue;
            known.push(product.partNumber.toLowerCase());
            self.Products.push(product);
        }

        self.RenderSelection();
    },

    RemoveProduct: (partNumber) => {
        const self = $.TemplateMarketingDirectoryProductExport;
        self.Products = self.Products.filter(
            (product) =>
                product.partNumber.toLowerCase() !== partNumber.toLowerCase(),
        );
        self.RenderSelection();
    },

    ClearProducts: () => {
        const self = $.TemplateMarketingDirectoryProductExport;
        self.Products = [];
        self.ShowUnknown([]);
        self.RenderSelection();
    },

    ShowUnknown: (unknown) => {
        const el = $("#export-unknown");
        el.empty();

        if (!unknown || unknown.length === 0) {
            el.addClass("d-none");
            return;
        }

        el.removeClass("d-none");
        el.append($("<strong></strong>").text(`${el.attr("data-message")}: `));
        el.append($("<span></span>").text(unknown.join(", ")));
    },

    Search: () => {
        const self = $.TemplateMarketingDirectoryProductExport;
        const list = $("#export-search-results");
        const search = $("#export-search-input").val();

        list.empty();
        $("#export-search-empty").addClass("d-none");

        if (!search || search.trim().length === 0) return;

        $.Backend.SearchProduct(search, self.Language(), false, true).then(
            (response) => {
                const products = response.data.products
                    ? response.data.products
                    : [];

                list.empty();
                if (products.length === 0) {
                    $("#export-search-empty").removeClass("d-none");
                    return;
                }

                for (let product of products) {
                    const item = $(
                        '<button type="button" class="list-group-item list-group-item-action"></button>',
                    );
                    item.attr("data-part-number", product.partNumber);
                    item.text(`${product.name} (${product.partNumber})`);
                    item.on("click", function () {
                        self.ToggleProduct({
                            partNumber: product.partNumber,
                            name: product.name,
                        });
                    });
                    list.append(item);
                }

                self.Refresh();
            },
        );
    },

    AddPastedProducts: () => {
        const self = $.TemplateMarketingDirectoryProductExport;
        const button = $("#export-paste-button");
        const partNumbers = ($("#export-paste-input").val() || "")
            .split(/[\n\r,;\t]+/)
            .map((value) => value.trim())
            .filter((value) => value.length > 0);

        if (partNumbers.length === 0) return;

        button.prop("disabled", true);
        $.Backend.MarketingDirectoryProductExportProducts(
            self.Language(),
            partNumbers,
            null,
        )
            .then((response) => {
                self.AddProducts(
                    response.data.products ? response.data.products : [],
                );
                self.ShowUnknown(
                    response.data.unknown ? response.data.unknown : [],
                );
                $("#export-paste-input").val("");
            })
            .catch(() => {})
            .finally(() => button.prop("disabled", false));
    },

    AddCategoryProducts: () => {
        const self = $.TemplateMarketingDirectoryProductExport;
        const button = $("#export-category-button");
        const category = $("#export-category-input").val();

        if (!category) return;

        button.prop("disabled", true);
        $.Backend.MarketingDirectoryProductExportProducts(
            self.Language(),
            null,
            category,
        )
            .then((response) => {
                self.AddProducts(
                    response.data.products ? response.data.products : [],
                );
                self.ShowUnknown([]);
            })
            .catch(() => {})
            .finally(() => button.prop("disabled", false));
    },

    Download: () => {
        const self = $.TemplateMarketingDirectoryProductExport;
        const button = $("#export-download");
        const columns = self.SelectedColumns();

        if (self.Products.length === 0 || columns.length === 0) return;

        const language = self.SelectedLanguage();

        $("#downloadCartOverlay").addClass("show");
        $.Backend.MarketingDirectoryProductExport(
            {
                language: language.id,
                partNumbers: self.Products.map((product) => product.partNumber),
                columns,
                delimiter: $("input[name='export-delimiter']:checked").val(),
                richText: $("input[name='export-rich-text']:checked").val(),
            },
            language.key ?
                `${button.attr("data-file-name")}-${language.key}`
            :   button.attr("data-file-name"),
        ).then(() => $("#downloadCartOverlay").removeClass("show"));
    },
};

$(document).ready(function () {
    const modal = $("#product-export-modal");
    if (!modal.length) return;

    const self = $.TemplateMarketingDirectoryProductExport;

    modal.on("show.bs.modal", function () {
        const navigation = document.getElementById("navigation");
        const offcanvas = navigation
            ? bootstrap.Offcanvas.getInstance(navigation)
            : null;
        if (offcanvas) offcanvas.hide();

        self.GoToStep(self.Step);
    });

    $("#export-search-button").on("click", () => self.Search());
    $("#export-search-input").on("keyup", function (e) {
        if (self.SearchTimeout) clearTimeout(self.SearchTimeout);
        if (e.key === "Enter") {
            self.Search();
            return;
        }
        self.SearchTimeout = setTimeout(() => self.Search(), 500);
    });

    $("#export-paste-button").on("click", () => self.AddPastedProducts());
    $("#export-category-button").on("click", () => self.AddCategoryProducts());
    $("#export-selection-clear").on("click", () => self.ClearProducts());

    $("#export-columns").on("change", "input[data-column]", () => self.Refresh());
    $("#export-columns").on(
        "change",
        "input[data-group]:not([data-column])",
        function () {
            const group = $(this).attr("data-group");
            $(
                `#export-columns input[data-column][data-group='${group}']`,
            ).prop("checked", $(this).prop("checked"));
            self.Refresh();
        },
    );

    $("#export-columns-all").on("click", function () {
        $("#export-columns input[type='checkbox']").prop("checked", true);
        self.Refresh();
    });
    $("#export-columns-none").on("click", function () {
        $("#export-columns input[type='checkbox']").prop("checked", false);
        self.Refresh();
    });

    $("#product-export-modal").on(
        "change",
        "input[name='export-language']",
        () => self.Refresh(),
    );

    $("#product-export-modal .export-progress .step").on("click", function () {
        const step = parseInt($(this).closest("li").attr("data-step"), 10);
        if (step < self.Step) self.GoToStep(step);
    });

    $("#export-back").on("click", () => self.GoToStep(self.Step - 1));
    $("#export-next").on("click", () => self.GoToStep(self.Step + 1));
    $("#export-download").on("click", () => self.Download());

    self.GoToStep(1);
});
